import styled from 'styled-components';
import { Button, TextField, CardContent } from '@mui/material';
import { CardHeader } from '@mui/material';


export const PageContainer = styled.div`
  min-height: 100vh;
  background-color: var(--gray-50);
`;

export const Container = styled.div`
  height: 100%;
  padding: 0 1rem;
  overflow: auto;
`;

export const Title = styled.h1`
  font-size: var(--font-size-mid);
  font-weight: bold;
  margin-bottom: 0.625rem;
  color: var(--text-primary);
`;

export const Subtitle = styled.p`
  font-size: var(--typography-body-1-link-size);
  margin-bottom: var(--padding-base);
  color: var(--text-secondary);
`;

export const QuestionTypeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 0.625rem;
  width: 100%;
  margin-bottom: var(--padding-base);

  @media (min-width: 768px) {
    width: 96.5%;
  }
`;

export const RadioButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: center;
  align-items: end;
`;

export const RadioButtonLabel = styled.label`
  font-size: var(--typography-body2-size);
  font-style: normal;
  font-weight: 100;
  line-height: 166%;
  letter-spacing: 0.4px;
  padding-bottom: 0.5rem;
`;

export const KnowledgeBaseButton = styled.a`
  font-size: var(--font-size-mid);
  display: inline-block;
  cursor: pointer;
  && {
    color: var(--primary-blue);
    text-decoration: none;
    text-transform: none;
    
    &:hover {
      text-decoration: underline;
      background: transparent;
    }
  }
`;

export const StyledButton = styled(Button)`
  margin-top: var(--padding-base);
  background-color: var(--secondary-main);
  color: var(--primary-contrast);
  width: 100%;
  &:hover {
    background-color: var(--primary-blue);
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--padding-base);
`;

export const PopupTitle = styled.h2`
  font-size: var(--typography-h5-size);
  font-weight: bold;
  color: var(--text-primary);
`;

export const ModalText = styled.p`
  margin-bottom: var(--padding-base);
`;

export const SearchSection = styled.div`
  width: 100%;
  padding: 20px;
  background: white;
  border-radius: var(--borderRadius);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
  text-align: center;
`;

export const SearchWrapper = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`;

export const StyledTextField = styled(TextField)`
  && {
    .MuiInputBase-root {
      padding-left: 40px;
      height: 3rem !important;
    }
  }
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-secondary);
`;

export const QueryTypeLabel = styled.label`
  display: flex;
  align-items: center;
  border: 1px solid var(--background-info);
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 16px;
  width: 100%;
  height: 3rem;
  
  &:hover {
    background: var(--background-info);
  }
`;

export const SearchHeader = styled.p`
  text-align: center;
  color: var(--text-primary);
  margin-bottom: 24px;
  font-size: var(--font-size-mid);
`;

export const OrDivider = styled.div`
  text-align: center;
  color: var(--text-primary);
  margin: 16px 0;
  font-size: 1rem;
  
  span {
    margin-right: 8px;
  }
`;

export const SearchButton = styled.a`
  max-width: 2rem !important;
  margin-top: 0 !important;
  text-transform: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  border-radius: 4px;
  background-color: var(--secondary-main);
  color: var(--primary-contrast);
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background-color: var(--primary-blue);
    text-decoration: none;
  }

  @media (min-width: 768px) {
    max-width: 7rem !important;
  }
`;

export const StyledCardContent = styled(CardContent)`
  && {
    padding: 24px;
    
    &:last-child {
      padding-bottom: 24px;
    }
  }
`;